module.exports = __webpack_public_path__ + "media/images/wizart-f4bf78673b3badd1aabac6f020a38503.jpeg";